"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconMAAC = function SvgIconMAAC(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "m a a c icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'M A A C Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.16 8.2v25.555h-8.67a6.546 6.546 0 01-13.091 0H18.09a6.546 6.546 0 01-13.091 0v-6.694H34.49V8.2h8.668zM11.545 30.483a3.272 3.272 0 100 6.546 3.279 3.279 0 003.273-3.274 3.274 3.274 0 00-3.273-3.272zm16.4 0a3.272 3.272 0 100 6.546 3.279 3.279 0 003.273-3.274 3.274 3.274 0 00-3.273-3.272zM15.476 8.611a1.162 1.162 0 012.046 0l7.34 13.693A1.153 1.153 0 0123.84 24H9.16a1.154 1.154 0 01-1.022-1.696zM16.5 19.388c-.64 0-1.16.516-1.16 1.153 0 .636.52 1.153 1.16 1.153.64 0 1.158-.517 1.158-1.153 0-.637-.519-1.153-1.158-1.153zm1.158-5.766h-2.317v4.612h2.317v-4.612z"
  }));
};

var _default = SvgIconMAAC;
exports.default = _default;